import { ApiStatus } from "./api.types";
export interface IDocumentSetting {
    _id: string
}

export interface IDocumentSettings {
    documentSettings: IDocumentSetting[];
}

/**
 * Interface for DocumentSetting State.
 */
export interface IDocumentSettingSliceState {
    documentSettings: IDocumentSetting[];
    status: ApiStatus;
    errorMessage: string | undefined;
    isDocumentSettingCreated: boolean;
    documentSettingDetails: IDocumentSetting | undefined;
    selectedDocumentSettingId: string;
}

export interface IDocumentSettingResponse {
    documentSetting: IDocumentSetting,
    message: string;
}

export interface ISubscriptions {
    subscriptions: ISubscriptions[]
}

export interface ILedger {
    _id: string;
    ledgerName: string;
    accountingCode: string;
    seqNumber: string;
}

export type DocNumberFormat = 'prefix' | 'suffix' | 'both' | 'none';
export type PrefixSuffixType = 'custom' | 'date';

export const resolveDateFormatPreview = (format: string): string => {
    const now = new Date();
    const y = now.getFullYear();
    const yy = String(y).slice(-2);
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const mmm = monthNames[now.getMonth()];
    const map: Record<string, string> = {
        YYYY: String(y), YY: yy, MM: m, DD: d, MMM: mmm,
        YYMM: yy + m, YYYYMM: String(y) + m, MMYY: m + yy, MMYYYY: m + String(y),
        YYYYMMDD: String(y) + m + d, DDMMYY: d + m + yy,
        MMMYY: mmm + yy, MMMYYYY: mmm + String(y),
    };
    return map[format] || format;
};

const DATE_FORMAT_KEYS = [
    'YYYY', 'YY', 'MM', 'MMM', 'YYMM', 'YYYYMM', 'MMYY', 'MMYYYY', 'YYYYMMDD', 'DDMMYY', 'MMMYY', 'MMMYYYY'
];

export const getDateFormatOptions = () =>
    DATE_FORMAT_KEYS.map(key => ({
        label: `${key} (${resolveDateFormatPreview(key)})`,
        value: key,
    }));

export interface IDocumentSettingFormInputs {
    docNumberPrefix: string;
    docNumberSuffix?: string;
    docNumberFormat?: DocNumberFormat;
    prefixType?: PrefixSuffixType;
    suffixType?: PrefixSuffixType;
    prefixDateFormat?: string;
    suffixDateFormat?: string;
    prefixSeparator?: string;
    suffixSeparator?: string;
    docSequenceNumber: string;
    docNumberLength: string;
    termsAndConditions: string;
    paymentDetails: string;
    paymentTermDays?: number;
    defaultPdfTemplate?: string;
    notes: string;
    footer1: string;
    footer2: string;
    smsAndWhatsAppText: string;
    emailSubject: string;
    emailText: string;
    tagsMandatory?: boolean;
    status: string;
    account: string;
    documentType: string;
    ledgers?: string[];
    _id?: string;
}

export interface IDocumentSettingDeleteResponse {
    message: string;
    id: string;
}

export interface IDocumentSettingUpdatePayload {
    documentSettingPayload: IDocumentSettingFormInputs;
    id: string;
}
